module.exports = function () {
  var $ = require('boxjs/dist/utils/_bdboxWrapper');
  /* eslint-disable */

  /**
   * @namespace Bdbox.ios
   */

  /**
   * ios.invokeApp，因为需要创建iframe，所以回调是异步的请求
   * @memberOf Bdbox.ios
   * @function
   * @name invokeApp
   * @param  {String}   action   调用的action，例如downloadnovel
   * @param  {Object}   params   参数对象
   * @param  {Function} callback 回调函数
   * @example
   * Bdbox.ios.invokeApp('getspeedlogdata', function(cData) {
   *     console.log(cData);
   * });
   * Bdbox.ios.invokeApp('downloadnovel', {
   *     url:'xxxx',
   *     title: 'xxxxxxx'
   * }, function(cData) {
   *     if(cData.error==0){
   *         console.log('success');
   *         alert(cData.result);
   *     }else{
   *         console.log('fail');
   *     }
   * });
   * $Id: invokeApp.js 286585 2016-03-15 11:57:15Z wangyongqing01 $
   */


  return function (action, params, callback) {
    //baiduboxapp://jsbridge?action=ios-action&func=js-func-name&params=ios-action-arguments
    if (!action || !$.isBoxApp()) {
      return;
    }

    var url = [];

    if ($.isFunction(params)) {
      callback = params;
    } else {
      for (var i in params) {
        url.push(i + '=' + params[i]);
      }
    }

    if ($.isFunction(callback)) {
      var funcName = '_bdbox_js_' + $.getId();

      window[funcName] = function () {
        callback.apply(window, [].slice.call(arguments, 0));
        /*delete window[funcName];*/
      };

      url.push('func=' + funcName);
    } else {
      if (callback) {
        url.push('func=' + callback);
      }
    }

    url = 'baiduboxapp://' + action + '?' + url.join('&'); // console.log(decodeURIComponent(url));

    var $node = document.createElement('iframe');
    $node.style.display = 'none';
    $node.src = url;
    var body = document.body || document.getElementsByTagName('body')[0];
    body.appendChild($node); // 销毁 iframe

    setTimeout(function () {
      body.removeChild($node);
      $node = null;
    }, 0);
  };
}();